import React, {useContext, useEffect, useState} from "react";
import SetItemsContext from "../../tools/contexts/authenticatonService/SetItemsContext";
import {FaAngleLeft, FaCheckSquare} from "react-icons/fa";
import {Price} from "../../tools/helpers";
import Button from "../Button";
import BottomButtonWrapper from "../BottomButtonWrapper";
import {Reoverlay} from "reoverlay";
import SuccessStageModal from "../modals/SuccessStageModal";
import DivarLadderModal from "../modals/DivarLadderModal";
import LoadingScreen from "../LoadingScreen";
import Api from "../../tools/service";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";

const ServiceCard = ({type, item, isRequired}) => {
    const setItemsContext = useContext(SetItemsContext);
    const [discountPercent, setDiscountPercent] = useState(null);

    useEffect(() => {

        if (setItemsContext.data.discount) {
            if (type === "post") {
                setDiscountPercent(setItemsContext.data.discount.props[item.service_type].post_add_on)
            } else {
                setDiscountPercent(setItemsContext.data.discount.props[item.service_type].user_add_on)
            }

        }


    }, [])


    const handleSelectedServices = (value) => {

        const isSelected = setItemsContext.selectedServices.filter((item, index) => value.service_type === item.service_type);
        if (isSelected && isSelected.length > 0) {
            const newSelectedItems = setItemsContext.selectedServices.filter(selectedService => {
                if (selectedService.required_services.includes(value.service_type)) {
                    return false
                } else return value.service_type !== selectedService.service_type;
            })
            setItemsContext.handleChangeSelectedServices([...newSelectedItems])


        } else {
            let newSelectedServices = [item, ...setItemsContext.selectedServices];
            const selectedItems = setItemsContext.selectedServices.map(s => s.service_type);
            const serviceRequiredServices = item.required_services;
            serviceRequiredServices.forEach((sR) => {
                if (!selectedItems.includes(sR)) {
                    setItemsContext.data.items.forEach((i => {
                        if (i.service_type === sR) {
                            newSelectedServices.push(i)
                        }
                    }))
                }
            })
            if (value?.note) {
                Reoverlay.showModal(SuccessStageModal, {
                    title: '',
                    subTitle: value.fa_title || '',
                    showIcon: false,
                    showTitle: false,
                    theme: "green",
                    description: value.note,
                    closeButtonText: 'بستن',
                    nextStepText: 'بستن',
                    onConfirm: () => {
                        Reoverlay.hideModal();
                    }
                })
            }
            setItemsContext.handleChangeSelectedServices([...newSelectedServices])
        }
    }
    if (isRequired) {
        return <div key={item.service_type + 'main'}
                    className={`w-full flex flex-col relative border-2 border-green-500  bg-white mb-4 p-5 rounded-lg`}>
            {discountPercent > 0 &&
                <span className="discount">{discountPercent === 100 ? 'رایگان' : `${discountPercent}% تخفیف`}</span>}
            <div className="flex  items-center justify-between">
                <h5 className="font-bold">{item.fa_title || item.service_type}</h5>
                <div className="w-5 bg-gray-100 h-5 border-rounded">
                    <FaCheckSquare className="text-xl  text-green-500 "/>
                </div>

            </div>
            <p className="mt-2  text-sm text-wrap">{type === "post" ? item?.description : item?.add_on_description}</p>
        </div>
    } else {
        return <div key={item.service_type + 'main'}
                    className={`w-full flex flex-col border-2  relative bg-white mb-4 p-5  rounded-lg `}>
            {discountPercent > 0 &&
                <span className="discount">{discountPercent === 100 ? 'رایگان' : `${discountPercent}% تخفیف`}</span>}
            <div onClick={() => handleSelectedServices(item)} className="flex  items-center justify-between">
                <h5 className="font-bold">{item.fa_title || item.service_type}</h5>
                <div className="w-5 bg-gray-100 h-5 border-rounded">
                    {setItemsContext.selectedServices.map((value, index) => (value.service_type)).includes(item.service_type) &&
                        <FaCheckSquare className="text-xl  text-green-500 "/>}
                </div>

            </div>

            <p className=" text-sm border-t mt-2 pt-2">{item.description}</p>
            <div className="w-full mt-2 pt-2 flex justify-between items-center border-t">
                <div onClick={() => {
                    setItemsContext.handleShowOption(item.service_type)
                }} className="  w-full items-center  flex justify-between  ">
                    <span className=" text-xs">توضیحات بیشتر </span>
                    <FaAngleLeft className="text-sm text-gray-500"/>
                </div>
            </div>

        </div>
    }
}


const SelectServices = () => {
    const setItemsContext = useContext(SetItemsContext);
    const serviceContext = useContext(AuthenticationServiceContext)
    const calculatePrice = (priceContext) => {
        if (!priceContext) return null;
        const {hasDiscount, showOff, price, payablePrice, priceWithDiscount} = priceContext;
        const originalPrice = price / 10
        const payable = payablePrice / 10
        const discountedPrice = priceWithDiscount / 10

        if (hasDiscount) {
            return {
                originalPrice: showOff ? originalPrice : payable,
                finalPrice: discountedPrice,
            };
        }

        return {
            originalPrice: showOff ? originalPrice : null,
            finalPrice: payable,
        };
    };
    const [ladderLoading,setLadderLoading]=useState(false);
    const handleGetLadderPrice=()=>{
        setLadderLoading(true);
        Api.get(REQUEST_URLS.AUTHENTICATION.GET_LADDER_PRICE,{
            headers: {
                "Authorization": `Bearer ${serviceContext.token}`
            },
            params:{
                pid:serviceContext.pid,
            }
        }).then(response=>{
            if(response.hasError){
                setItemsContext.handleConfirm()
            }else {
                const price = calculatePrice(setItemsContext?.price);
                const reorder=response.data.reorder;
                if(reorder&&reorder.cost_rials&&reorder?.available){
                    Reoverlay.showModal(DivarLadderModal, {
                        price: price,
                        ladderPrice:(+reorder.cost_rials/10),
                        onConfirm: (selectLadder) => {
                            Reoverlay.hideModal();
                            setItemsContext.handleConfirm(selectLadder)
                        }
                    })
                }else {
                    setItemsContext.handleConfirm()
                }

            }
        }).finally(()=>{
            setLadderLoading(false)
        })

    }
    const handleConfirm = () => {
        if (setItemsContext.data.can_nardeban && setItemsContext.selectedType === 'post') {
            handleGetLadderPrice()
        } else {
            setItemsContext.handleConfirm()
        }


    }
    if(ladderLoading){
        return <LoadingScreen text={'در حال دریافت اطلاعات'}/>
    }
    return <div className="flex w-11/12 mx-auto pb-36 lg:w-6/12 2xl:w-4/12 justify-center flex-col items-center">
        <h1 className="text-2xl text-center mt-6 mb-5 font-bold">
            {setItemsContext?.data.general_settings.top_main_title}
        </h1>
        {setItemsContext.requiredServices.map((item, index) => <ServiceCard
            type={setItemsContext.selectedType}
            key={index + 'required'}
            item={item}
            isRequired={true}/>)
        }
        {setItemsContext.selectedType === "post" && <>
            {setItemsContext.optionalServices.length > 0 && <h1 className="mb-2 mt-5 ">
                {setItemsContext?.data.general_settings?.suggestion_msg}
            </h1>}
            {setItemsContext.optionalServices.map((item, index) => <ServiceCard
                type={setItemsContext.selectedType}
                key={index + 'optional'}
                item={item}
                isRequired={false}/>)
            }
        </>
        }
        <BottomButtonWrapper>
            <div className="w-full flex justify-between items-end">
                <span>مبلغ پرداختی</span>
                <div className="flex flex-col ">
                    {(setItemsContext?.price && setItemsContext?.price?.hasDiscount) && <>
                        <small
                            className="text-sm font-bold text-red-400 line-through">{setItemsContext.price.showOff ? Price(setItemsContext.price.payablePrice / 10) : Price(setItemsContext.price.payablePrice / 10)}<span
                            className="mx-1 "> تومان </span> </small>
                        {setItemsContext.price.priceWithDiscount > 0 ? <span
                            className="text-lg font-bold text-green-400">{Price(setItemsContext.price.priceWithDiscount / 10)}
                            <small> تومان </small>
                        </span> : <span
                            className="text-lg font-bold text-green-400">
                            رایگان
                        </span>}

                    </>}
                    {setItemsContext.price && !setItemsContext?.price?.hasDiscount && <>
                        {setItemsContext.price.showOff && <small
                            className="text-sm font-bold text-red-400 line-through">{Price(setItemsContext.price.price / 10)}<span
                            className="mx-1 "> تومان </span> </small>
                        }
                        <span
                            className="text-lg font-bold text-green-400">{Price(setItemsContext.price.payablePrice / 10)}
                            <small> تومان </small></span>
                    </>}


                </div>

            </div>
            <div
                className={`grid  mt-3 border-t pt-3 gap-2 grid-cols-2`}>
                <Button onClick={() => {
                    setItemsContext.handleChangeSelectedServices([...setItemsContext.requiredServices]);
                    setTimeout(() => {
                        setItemsContext.handleStep(1);
                    }, 100)
                }} rounded="rounded-lg" className="text-sm  " theme="light">بازگشت</Button>
                <Button onClick={handleConfirm} rounded="rounded-lg" className="text-sm  "
                        theme="green">ادامه</Button>
            </div>
        </BottomButtonWrapper>
    </div>
}
export default SelectServices